/**
 * Groups a collection of objects that share a common property by the values set for that property
 * @param entities Array of objects with a common `key` property
 * @param key A key to group by
 * @returns A dictionary of objects
 */
const keyBy = (entities, key) => entities.reduce((dictionary, entity) => {
  dictionary[entity[key]] = entity;
  return dictionary;
}, {});
export default keyBy;
//# sourceMappingURL=keyBy.js.map